/**
 * FontIcon.js
 * Font icon component for Font Awesome
 *
 * @class  FontIcon
 * @author Randy Lebeau
 *
 */

import React from 'react';
import ClassNames from 'classnames';

export default React.createClass({

    propTypes: {
        icon: React.PropTypes.string.isRequired,
        magnify: React.PropTypes.oneOf([1, 2, 3, 4, 5]),
        fixedWidth: React.PropTypes.bool,
        border: React.PropTypes.bool,
        float: React.PropTypes.oneOf(['left', 'right']),
        animation: React.PropTypes.oneOf(['spin', 'pulse']),
        rotate: React.PropTypes.oneOf([90, 180, 270]),
        flip: React.PropTypes.oneOf('horizontal', 'vertical'),
        onClick: React.PropTypes.func,
        status: React.PropTypes.oneOf(['success', 'error', 'alert', 'primary', 'secondary']),
        padding: React.PropTypes.string,
        margin: React.PropTypes.string
    },
    getDefaultProps() {
        return{
            magnify: 1
        }
    },

    render() {

        let {
            icon,
            magnify,
            fixedWidth,
            border,
            float,
            animation,
            rotate,
            flip,
            stacked
        } = this.props;

        let classes = ClassNames('fa-' + icon, this.props.className, {
            'fa': true,
            'fa-fw': fixedWidth,
            'fa-border': border,
            // magnify
            'fa-2x': this.props.magnify === 2,
            'fa-3x': magnify === 3,
            'fa-4x': magnify === 4,
            'fa-5x': magnify === 5,
            // float
            'fa-pull-left': float === 'left',
            'fa-pull-right': float === 'right',
            // animation
            'fa-spin': animation === 'spin',
            'fa-pulse': animation === 'pulse',
            // flip
            'fa-flip-horizontal': flip === 'horizontal',
            'fa-flip-vertical': flip === 'vertical',
            // rotate
            'fa-rotate-90': rotate === 90,
            'fa-rotate-180': rotate === 180,
            'fa-rotate-270': rotate === 270,
            'lui-text-success': this.props.status === 'success',
            'lui-text-alert': this.props.status === 'alert',
            'lui-text-error': this.props.status === 'error',
            'lui-text-primary': this.props.status === 'primary',
            'lui-text-secondary': this.props.status === 'secondary'
        });

        let styles = {
            padding: this.props.padding || '0',
            margin: this.props.margin || '0'
        };

        return (
            <span className={classes} style={styles} onClick={this.props.onClick ? this.props.onClick : null} />
        );

    }

});




/** WEBPACK FOOTER **
 ** ./src/components/font-icon/FontIcon.js
 **/